'use strict';

// set webkit size
window.moveTo(0, 0);
window.resizeTo(screen.width, screen.height);


// mouse click
window.onclick = function () { return false; };

// prevent default right-click menu only for releases
window.oncontextmenu = function () { return false; };


function getRandomInt ( min, max ) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function run ( element ) {
    var date    = new Date(),
        minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
        time    = date.getHours() + ':' + minutes;

    // set random coordinates for clock element. Set borders to prevent element from cutting
    element.style.top = getRandomInt(100, (screen.height - 100)) + 'px';
    element.style.left = getRandomInt(100, (screen.width - 200)) + 'px';
    element.innerHTML = time;
}

function startRunning () {
    var clockSaver = document.createElement('div');

    document.body.appendChild(clockSaver);
    clockSaver.className = 'clock';
    clockSaver.style.top = '100px';
    clockSaver.style.left = '100px';
    // hide keyboard
    //    gSTB.HideVirtualKeyboard();
    // set screen saver interval
    setInterval(function () {
        run(clockSaver);
    }, 10000);
}

// dom is ready
window.onload = function () {
    startRunning();
};
